<template>
  <el-row>
    <el-col :span="24">
      <div  class="leftnav" :style="{'height':ileftHeight +'px'}">
        <ul>
          <li v-for="(item,index) in deps" :key="index" :class="selectdep == item.id?'dd-this':''" @click="changedep(item);"><span>{{item.text}}</span><i></i></li>
        </ul>
      </div>
      <div class="main" :style="{'height':ibHeight +'px'}">
        <el-row class="mainbox">
          <el-col :span="24" v-if="selectdep == 1">
            <el-col :span="24">
              <el-col :span="24">
                <el-form    :inline="true"   label-width="80px" class="demo-form-inline searchbox">
                  <el-form-item label="关键词：">
                    <el-input @keyup.native.enter="query" v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入设备名称或内容查询..."></el-input> 
                  </el-form-item>
                  <el-form-item label="企业：">
                     <el-select v-model="qiyeid" placeholder="请选择" @change="query">
                        <el-option
                        v-for="item in changjialist"
                        :key="item"
                        :label="item.label"
                        :value="item.id">
                        </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="日期：">
                   <el-date-picker  @change="query"
                  v-model="time"
                   
                   type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
                 >
                </el-date-picker> 
                
                     <el-radio-group v-model="radioval" style="margin-left:10px" @change="query">
                        <el-radio label="-1" >全部</el-radio>
                        <el-radio label="32">只看警报</el-radio> 
                    </el-radio-group>
                  
                <el-button style="margin-left:10px;" icon="el-icon-search" type="success" @click="query">快速查询</el-button>
                  </el-form-item>
                  </el-form>
              </el-col>
               
              
              
            </el-col>
            <el-col :span="24" style="background:rgba(0,217,255,.15);padding:10px; ">
              <el-row>

                <el-col :span="24">

                <el-table
                  :data="data"
                  style="width: 100%"
                  border
                   v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
                  :height="boxHeight">
                   <el-table-column
                    type="index"
                    align="center"
                      label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    
                    prop="imei"
                    label="设备IMEI"
                    align="center"
                    width="160">
                  </el-table-column>
                  <el-table-column
                   
                    prop="name"
                    label="企业"
                    width="160">
                  </el-table-column>
                  <el-table-column
                 
                    prop="devicename"
                    label="设备名称"
                    
                    min-width="100">
                  </el-table-column>

                  <el-table-column
                 
                    prop="devicemodel"
                    label="设备型号"
                    
                    min-width="100">
                  </el-table-column>
                  <el-table-column
                 
                    prop="specs"
                    label="设备规格"
                    
                    min-width="100">
                  </el-table-column>
                  
                    <el-table-column
                   
                    prop="type"
                    label="内容类别"
                    min-width="100">
                  </el-table-column>
                  <el-table-column
                   
                    prop="desc"
                    label="内容"
                    min-width="180">
                  </el-table-column>
                  <el-table-column
                  
                    prop="createtimestr"
                    label="发生时间"
                    align="center"
                    width="180">
                  </el-table-column>
                   
                   
                </el-table>

              </el-col>
              <el-col style="margin-top:10px;text-align:center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
               @current-change="handleCurrentChange"
                  :page-size="limit"
                  :total="total">
                </el-pagination>
              </el-col>

              </el-row>

            </el-col>
           </el-col>
          <el-col :span="24" v-else-if="selectdep == 2" >
            <el-col :span="24" >
                <el-col :span="24">
                <el-form    :inline="true"   label-width="80px" class="demo-form-inline searchbox">
                  <el-form-item label="关键词：">
                    <el-input @keyup.native.enter="query" v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入检索内容等查询..."></el-input> 
                  </el-form-item>
                   
                  <el-form-item label="日期：">
                   <el-date-picker  @change="query"
                  v-model="time"
                  type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
                </el-date-picker> 
                <el-button style="margin-left:10px;" icon="el-icon-search" type="success" @click="query">快速查询</el-button>
                  </el-form-item>
                  </el-form>
              </el-col>
            </el-col>
            <el-col :span="24" style="background:rgba(0,217,255,.15);padding:10px; ">
              <el-row>

                <el-col :span="24">
                <el-table
                  :data="data"
                  style="width: 100%"
                  border
                  v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
                  :height="boxHeight">
                  <el-table-column
                    type="index"
                    align="center"
                      label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    
                    prop="username"
                    label="操作用户"
                    width="150">
                  </el-table-column>
                  <el-table-column
                  
                    prop="modul"
                    label="操作模块"
                    align="center"
                    width="150">
                  </el-table-column>
                  <el-table-column
                  
                    prop="desc"
                    label="操作内容"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                  
                    prop="createtimestr"
                    label="操作时间"
                    align="center"
                   width="180">
                  </el-table-column>
                </el-table>

              </el-col>
              <el-col style="margin-top:10px;text-align:center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="limit"
                  :total="total">
                </el-pagination>
              </el-col>

              </el-row>

            </el-col>
          </el-col>
        
        </el-row>
      </div>
    </el-col>

  </el-row>
</template>

<script>

 import {getqiyetoselect,getrizhilist} from '../api/api'

export default {
    data(){
        return {
          loading:false,
            deps:[{
                text:'设备日志',
                id:1
            },{
                text:'操作日志',
                id:2
            }],
            qiyeid:null,
            selectdep:1,
            data:[],
            
            changjialist:[],
            keyword:'',
            time:'',
            radioval:"-1",
             total:0,
      limit:10,
      page:1,

        }
    },
    computed:{
        ibHeight(){
        
        return window.innerHeight - 106;
        },
        ileftHeight(){
       
      return window.innerHeight - 126;
    },
    boxHeight() {
      return window.innerHeight - 300;
    },
    },
    created(){
      this.getqiyelist();
      this.query();
    },
    methods:{
      query(){
        let that = this;
        let type = this.selectdep ==2?0:(this.radioval == "-1"?2:this.radioval);
        that.loading = true;
        let time = "";
        this.time = this.time || {};
        if(this.time.length == 2 && typeof this.time == "object"){
          let year = this.time[0].getFullYear(); // 年
          let month = this.time[0].getMonth() + 1; // 月
          let day = this.time[0].getDate(); // 日
          time = `${year}-${month}-${day}`;

          year = this.time[1].getFullYear(); // 年
          month = this.time[1].getMonth() + 1; // 月
          day = this.time[1].getDate(); // 日

           time += `,${year}-${month}-${day}`;
        }

        getrizhilist({keyword:this.keyword,page:this.page,limit:this.limit,time:time,type:type,qiyeid:this.qiyeid}).then(res=>{
          that.total = res.data.count;
          that.data = res.data.list;
          setTimeout(() =>{
          that.loading = false;
        },200)
        })
      },
       handleCurrentChange(val){
      this.page = val;
      this.query();
    },
      getqiyelist(){
      let that = this;
      getqiyetoselect().then(res=>{
        that.changjialist = res.data;
      })
    },
        changedep(opt){
        if(this.selectdep != opt.id){
            this.selectdep = opt.id;
            this.qiyeid = null;
            this.page = 1;
            this.keyword = "";
            this.query();
        }
        },
    }
}
</script>

<style scoped>

</style>